import HeaderSearchInputIcon from "@gaiaProfessionals/Icons/HeaderSearchInputIcon";
import SearchInput, { SearchInputStyles } from "@gaiaProfessionals/Widgets/HCP/Header/SearchInput";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import React from "react";
import { css } from "styled-components";

export interface HeaderSearchInputStyles {
    searchInputStyles?: SearchInputStyles;
}

export const searchInputStyles: HeaderSearchInputStyles = {
    searchInputStyles: {
        input: {
            iconProps: {
                src: HeaderSearchInputIcon,
                size: 60,
            },
            css: css`
                background: #f3f3f3 !important;
                border: 2px solid #d1412440 !important;
                border-radius: 10px !important;
            `,
            cssOverrides: {
                formInputWrapper: css`
                    button[class^="StyledButton-sc"] {
                        width: 90px;
                    }
                    button[class^="StyledButton-sc"] span[class^="IconWrapper-sc"] {
                        background: ${getColor("common.accent")};
                        border-radius: 0px 8px 8px 0px;
                        width: 100%;
                        padding: 0px;
                        svg {
                            width: 90px !important;
                            height: 24px !important;
                        }
                    }
                `,
            },
        },
        popoverContentBody: {
            _height: "100%",
            css: css`
                width: 45%;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                width: 100%;
                                left: 0;
                            `,
                            css`
                                width: 100%;
                                left: 0;
                            `,
                            css`
                                width: 100%;
                                left: 0;
                            `,
                            css`
                                width: 26%;
                            `,
                        ],
                        "minMax",
                    )}
            `,
        },
    },
};

export const HeaderSearchInput: React.FC<WidgetProps & { isAnimated?: boolean }> = ({ id, isAnimated = false }) => {
    const styles = useMergeStyles("headerSearchInput", searchInputStyles);

    return <SearchInput id={id} isAnimated={isAnimated} extendedStyles={styles.searchInputStyles} />;
};

const widgetModule: WidgetModule = {
    component: HeaderSearchInput,
    definition: {
        group: "Header",
        displayName: "HCP Search Input",
        allowedContexts: ["Header"],
    },
};

export default widgetModule;
